import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"font-weight":"bold"} }
const _hoisted_2 = { style: {"font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_ctx.service)
    ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        class: "borderbottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            sm: "8",
            class: "py-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.locale === 'fr' ? _ctx.service.beschreibungFr : _ctx.service.beschreibungDe), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            sm: "2",
            class: "py-0"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.service.limiteGigaByte) + " GB", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            sm: "2",
            class: "py-0",
            style: {"text-align":"right"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.service.preisProMonat.toFixed(2)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_row, {
        key: 1,
        class: "borderbottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            sm: "8",
            class: "py-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('einstellungen.services.noservicesadded')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            sm: "2",
            class: "py-0"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("-")
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, {
            sm: "2",
            class: "py-0",
            style: {"text-align":"right"}
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("0.00")
            ])),
            _: 1
          })
        ]),
        _: 1
      }))
}